export default import.meta.ROLLDOWN_FILE_URL_FSE1MB8CncEwJnPMLSvuow